export const PACKAGE_BASIC = "Gói cơ bản";
export const PACKAGE_FREE_TRIAL = "Gói dùng thử";
export const PACKAGE_SUPPORT = "Gói hỗ trợ";

export const BRAND_TYPE_KEIVI = 'Keivi'

/**
 * 0: Gói dùng thử / Trial
 * 1: Gói hỗ trợ / Support
 * 2: Gói chuyên nghiệp / Professional
 * 3: Gói cao cấp / Premium
 * 10: Gói đồng hành / Companion
 */

export const ID_PACKAGE_TRIAL = 0;
export const ID_PACKAGE_SUPPORT = 1;
export const ID_PACKAGE_PROFESSIONAL = 2;
export const ID_PACKAGE_PREMIUM = 3;
export const ID_PACKAGE_COMPANION = 10;

/**
 * 100: Trial
 * 101: Standard
 * 102: Premium
 * 103: Lite
 */

export const KEIVI_ID_PACKAGE_TRIAL = 100;
export const KEIVI_ID_PACKAGE_STANDARD = 101;
export const KEIVI_ID_PACKAGE_PREMIUM = 102;
export const KEIVI_ID_PACKAGE_LITE = 103;


export function getListPackageWithCheckSubscription(isKeivi: string) {
  return isKeivi ? [KEIVI_ID_PACKAGE_STANDARD, KEIVI_ID_PACKAGE_LITE] : [ID_PACKAGE_SUPPORT]
}
